import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ELocalStorage } from '../enums/ELocalStorage';
import { AdminUser, LoginResponse } from '../interfaces/login-response.interface';

@Injectable({ providedIn: 'root' })
export class AuthService {
    private readonly router = inject(Router);

    tokenApiUser = '';
    tokenDBUser = '';
    user: AdminUser | null = null;

    init(): void {
        [ELocalStorage.AM_AUTH, ELocalStorage.DEFAULT_AM_AUTH].forEach(key => {
            const raw = localStorage.getItem(key);
            if (raw === 'undefined' || raw === 'null') localStorage.removeItem(key);
        });

        const amAuth = this.validToken(localStorage.getItem(ELocalStorage.AM_AUTH));
        const dbUserAuth = this.validToken(localStorage.getItem(ELocalStorage.DEFAULT_AM_AUTH));
        const stored = localStorage.getItem(ELocalStorage.USER);

        if (amAuth) this.tokenApiUser = amAuth;
        this.tokenDBUser = dbUserAuth || '';
        if (stored) {
            try {
                this.user = JSON.parse(stored);
            } catch { /* ignore */ }
        }
    }

    private validToken(val: string | null): string | null {
        if (!val || val === 'undefined' || val === 'null') return null;
        return val;
    }

    setFromLoginResponse(resp: LoginResponse): void {
        this.tokenApiUser = resp.tokenResp[0].token;
        this.tokenDBUser = this.validToken(resp.tokenResp[1]?.token ?? null) ?? '';
        this.user = resp.user;

        localStorage.setItem(ELocalStorage.AM_AUTH, this.tokenApiUser);
        localStorage.setItem(ELocalStorage.DEFAULT_AM_AUTH, this.tokenDBUser);
        localStorage.setItem(ELocalStorage.USER, JSON.stringify(resp.user));
    }

    clear(): void {
        this.tokenApiUser = '';
        this.tokenDBUser = '';
        this.user = null;
        localStorage.removeItem(ELocalStorage.AM_AUTH);
        localStorage.removeItem(ELocalStorage.DEFAULT_AM_AUTH);
        localStorage.removeItem(ELocalStorage.USER);
    }

    logout(): void {
        this.clear();
        this.router.navigateByUrl('/login').then();
    }

    isLoggedIn(): boolean {
        return !!this.tokenApiUser && !!this.user;
    }
}
